<script>
	import { _ } from 'svelte-i18n';
	import InfoButton from './InfoButton.svelte';

    export let component = null;
    export let hidden;
	export let info_active;
	export let step;

</script>

<style>
	.calculator {
		padding: var(--spacingXXLarge);
	}

	.calculator-title {
		position: relative;
	}

	.pagination {
		display: flex;
		justify-content: center;
		margin: var(--spacingXLarge) 0;
	}

	.pagination_step {
		width: 12px;
		height: 12px;
		margin: 0 7px;
		border-radius: 100%;
		border: 2px solid var(--colorElement);
	}

	.pagination_step.filled {
		background-color: var(--colorElement);
	}
</style>

<div class="calculator" id="calculate">
	<div class="calculator-title">
		<InfoButton {step} {hidden} {info_active}/>
		<h1>{$_('calculator.title')}</h1>
	</div>
	<div class="pagination">
		<div class="pagination_step filled"></div>
		<div class="pagination_step {step >= 2 ? 'filled' : ''}"></div>
		<div class="pagination_step {step === 3 ? 'filled' : ''}"></div>
	</div>

    <svelte:component this={component} />
</div>
